import { generateUtilityClasses } from '@mui/material';

import { KeyValuePairSize } from '../KeyValuePairItem';

export { KeyValuePairSize };

export const keyValuePairsClasses = generateUtilityClasses('KeyValuePairs', [
  'root',
  'groupTitleWrapper',
  'groupTitle',
  'spanGrid',
  'item',
  'divider',
]);
